import React, { useState } from 'react';
import './ContactSection.css';

const ContactSection = () => {
  const [formStatus, setFormStatus] = useState(null);

  const handleMapClick = () => {
    window.open('https://maps.google.com?q=77A+Bellegrove+Road,+Welling,+DA16+3PG', '_blank');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormStatus('Message sent! We’ll respond soon.');
    setTimeout(() => setFormStatus(null), 3000);
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <h2 className="contact-title">Get in Touch with Nand</h2>
        <div className="contact-stack">
          <div className="contact-info">
            <h3 className="info-title">Contact Us</h3>
            <div className="info-item">
              <span>77A Bellegrove Road, Welling, DA16 3PG</span>
            </div>
            <div className="info-item">
              <a href="tel:+447506003713">07506003713</a>
            </div>
            <div className="info-item">
              <a href="mailto:nandcashandcarry@gmail.com">nandcashandcarry@gmail.com</a>
            </div>
            <div className="info-item">
              <button className="map-link" onClick={handleMapClick}>
                View on Map
              </button>
            </div>
          </div>
          <div className="contact-form">
            <h3 className="form-title">Send a Message</h3>
            {formStatus && <p className="form-status">{formStatus}</p>}
            <form onSubmit={handleSubmit}>
              <div className="form-field">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  placeholder="Your name"
                  required
                  aria-required="true"
                />
              </div>
              <div className="form-field">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  placeholder="Your email"
                  required
                  aria-required="true"
                />
              </div>
              <div className="form-field">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  placeholder="Your message"
                  required
                  aria-required="true"
                />
              </div>
              <button type="submit">Send</button>
            </form>
          </div>
        </div>
        <a href="tel:+447506003713" className="call-sticky">
          Call Now
        </a>
      </div>
    </section>
  );
};

export default ContactSection;